module.exports = __webpack_public_path__ + "img/995.80b8eb4a.png";